import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';
import { shouldUseMockData } from '../config/dev';

const DevIndicator: React.FC = () => {
  if (!shouldUseMockData()) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: { xs: 23, sm: 75 },
        right: { xs: 16, sm: 20 },
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    >
      <Tooltip
        title="Mock AI mode is enabled. Set VITE_USE_MOCK_DATA=false to use real OpenAI API."
        arrow
      >
        <Chip
          label="🤖 MOCK DATA"
          size="small"
          sx={{
            backgroundColor: '#ff6b35',
            color: 'white',
            fontWeight: 'bold',
            fontSize: '0.75rem',
            '&:hover': {
              backgroundColor: '#e55a2b',
            },
          }}
        />
      </Tooltip>
    </Box>
  );
};

export default DevIndicator;
